export const ERROR_LIST = {
    studentAge: {
        errorText: "Your current age",
        label: "Student Age"
    },
    studentMaritalStatus: {
        errorText: "Student's marital status",
        label: "Student's Marital Status"
    },
    studentHasDependents: {
        errorText: "Indicate if you have dependents",
        label: "Student has dependents"
    },
    parentMaritalStatus: {
        errorText: "Parent's marital status",
        label: "Family Size"
    },
    familySize: {
        errorText: "Your family size including yourself",
        label: "Family Size"
    },
    parentIncomeEarnedBy: {
        errorText: "Indicate which parent earns the income",
        label: "Parent's Income Earned By"
    },
    parentAdjustedGrossIncome: {
        errorText: "Parent's adjusted gross income",
        label: "Parent(s) Adjusted Gross Income"
    },
    parentOtherIncome: {
        errorText: "Parent's other income.  Please type 0 if none.",
        label: "Parent(s) Other Income"
    },
    parentTaxesPaid: {
        errorText: "Parent's taxes paid for the most current year",
        label: "Parent(s) Taxes Paid"
    },
    parentAssets: {
        errorText: "Parent's total assets",
        label: "Parent(s) Assets"
    },
    studentIncomeEarnedBy: {
        errorText: "Student's income earned by",
        label: "Student's Income Earned By"
    },
    studentAdjustedGrossIncome: {
        errorText: "Your adjusted gross income",
        label: "Student Adjusted Gross Income"
    },
    studentOtherIncome: {
        errorText: "The amount of your other income. Please type 0 if none.",
        label: "Student Other Income"
    },
    studentTaxesPaid: {
        errorText: "Your taxes paid for the most current year.",
        label: "Student Taxes Paid"
    },
    studentAssets: {
        errorText: "Your total assets",
        label: "Student Assets"
    }
};